import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const jsonHeaders = () => ({ ...headers(), 'Content-Type': 'application/json' });

async function apiFetch(path: string) {
  const r = await fetch(`${API}${path}`, { headers: headers() });
  return r.ok ? r.json() : [];
}
async function apiPut(kod: string, body: any) {
  return fetch(`${API}/api/tanimlar2/kod/${encodeURIComponent(kod)}`, {
    method: 'PUT', headers: jsonHeaders(), body: JSON.stringify(body)
  });
}

const RENK = ['#1a5276', '#1f618d', '#2874a6', '#2e86c1'];

export default function FaaliyetAgac() {
  const _user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = ['super_admin', 'gm_yonetici'].includes(_user?.rol);

  const [duzListe, setDuzListe] = useState<any[]>([]);
  const [seciliPath, setSeciliPath] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modalAcik, setModalAcik] = useState(false);
  const [modalMod, setModalMod] = useState<'yeni' | 'duzenle' | 'tasi'>('yeni');
  const [form, setForm] = useState<any>({ kod: '', ust_kod: '', ad: '', modul_baglantisi: '', aciklama: '' });
  const [tasiHedef, setTasiHedef] = useState('');
  const [tasiItem, setTasiItem] = useState<any>(null);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [dragKod, setDragKod] = useState<string | null>(null);
  const [dragHedefKod, setDragHedefKod] = useState<string | null>(null);
  const [pasifleriGoster, setPasifleriGoster] = useState(false);
  const [searchParams] = useSearchParams();
  const kokFiltreParam = searchParams.get('kok');

  const yukle = async (gosterPasif?: boolean) => {
    const pasif = gosterPasif !== undefined ? gosterPasif : pasifleriGoster;
    setYukleniyor(true);
    const url = pasif
      ? '/api/tanimlar2/liste?sadece_yaprak=false&aktif=hepsi'
      : '/api/tanimlar2/liste?sadece_yaprak=false';
    const liste = await apiFetch(url);
    setDuzListe(liste);
    setYukleniyor(false);
  };

  useEffect(() => { yukle(pasifleriGoster); }, [pasifleriGoster]);

  useEffect(() => {
    if (!kokFiltreParam || duzListe.length === 0) return;
    const node = duzListe.find(d => d.kod === kokFiltreParam);
    if (node) setSeciliPath([node]);
  }, [kokFiltreParam, duzListe]);

  const getChildren = (ustKod: string | null) =>
    duzListe.filter(d => d.ust_kod === ustKod).sort((a, b) => (a.sira ?? 0) - (b.sira ?? 0));

  const secPanel = (seviye: number, dugum: any) =>
    setSeciliPath(prev => [...prev.slice(0, seviye), dugum]);

  const bildir = (msg: string) => { setMesaj(msg); setTimeout(() => setMesaj(''), 3000); };

  const yeniAc = (ustKod: string | null) => {
    setForm({ kod: ustKod ? `${ustKod}.` : '', ust_kod: ustKod || '', ad: '', modul_baglantisi: '', aciklama: '' });
    setHata(''); setModalMod('yeni'); setModalAcik(true);
  };

  const duzenleAc = (d: any) => {
    setForm({ kod: d.kod, _eskiKod: d.kod, ust_kod: d.ust_kod || '', ad: d.ad, modul_baglantisi: d.modul || '', aciklama: d.aciklama || '' });
    setHata(''); setModalMod('duzenle'); setModalAcik(true);
  };

  const tasiAc = (d: any) => {
    setTasiItem(d); setTasiHedef(d.ust_kod || '');
    setHata(''); setModalMod('tasi'); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.kod || !form.ad) { setHata('Kod ve ad zorunlu'); return; }
    try {
      if (modalMod === 'yeni') {
        const r = await fetch(`${API}/api/tanimlar2/ekle`, {
          method: 'POST', headers: jsonHeaders(),
          body: JSON.stringify({ kod: form.kod, ust_kod: form.ust_kod || null, ad: form.ad, modul_baglantisi: form.modul_baglantisi || null, aciklama: form.aciklama || null })
        });
        if (!r.ok) { const e = await r.json(); setHata(e.detail || 'Hata'); return; }
        bildir('✅ Eklendi');
      } else {
        const eskiKod = form._eskiKod || form.kod;
        if (eskiKod !== form.kod) {
          // Kod değişti: önce yeni kodu ekle, sonra eskiyi pasif yap
          const r1 = await fetch(`${API}/api/tanimlar2/ekle`, {
            method: 'POST', headers: jsonHeaders(),
            body: JSON.stringify({ kod: form.kod, ust_kod: form.ust_kod || null, ad: form.ad, modul_baglantisi: form.modul_baglantisi || null, aciklama: form.aciklama || null })
          });
          if (!r1.ok) { const e = await r1.json(); setHata(e.detail || 'Hata'); return; }
          await fetch(`${API}/api/tanimlar2/kod/${encodeURIComponent(eskiKod)}`, { method: 'DELETE', headers: headers() });
          bildir(`✅ Kod güncellendi: ${eskiKod} → ${form.kod}`);
        } else {
          const r = await apiPut(form.kod, { ad: form.ad, modul_baglantisi: form.modul_baglantisi || null, aciklama: form.aciklama || null, ust_kod: form.ust_kod || null });
          if (!r.ok) { const e = await r.json(); setHata(e.detail || 'Hata'); return; }
          bildir('✅ Güncellendi');
        }
      }
      setModalAcik(false);
      yukle();
    } catch { setHata('Bağlantı hatası'); }
  };

  const tasiKaydet = async () => {
    if (!tasiItem) return;
    try {
      const r = await apiPut(tasiItem.kod, { ad: tasiItem.ad, modul_baglantisi: tasiItem.modul || null, aciklama: tasiItem.aciklama || null, ust_kod: tasiHedef || null });
      if (!r.ok) { const e = await r.json(); setHata(e.detail || 'Hata'); return; }
      bildir(`✅ "${tasiItem.ad}" taşındı`);
      setModalAcik(false); yukle();
    } catch { setHata('Bağlantı hatası'); }
  };

  const sil = async (kod: string, ad: string) => {
    if (!window.confirm(`"${ad}" (${kod}) kalıcı olarak silinecek.\nBu işlem geri alınamaz. Devam edilsin mi?`)) return;
    try {
      const r = await fetch(`${API}/api/tanimlar2/kalici/${encodeURIComponent(kod)}`, { method: 'DELETE', headers: headers() });
      if (!r.ok) { const e = await r.json(); alert(e.detail || 'Hata'); return; }
      bildir('✅ Silindi');
      yukle();
      setSeciliPath(prev => prev.filter((d: any) => d.kod !== kod));
    } catch { alert('Bağlantı hatası'); }
  };

  const aktifEt = async (kod: string) => {
    try {
      await fetch(`${API}/api/tanimlar2/aktif/${encodeURIComponent(kod)}`, { method: 'PUT', headers: jsonHeaders(), body: JSON.stringify({}) });
      bildir('✅ Aktif edildi');
      yukle();
    } catch { alert('Hata'); }
  };

  // Sürükle-bırak
  const handleDragStart = (kod: string) => setDragKod(kod);
  const handleDragOver = (e: React.DragEvent, kod: string) => { e.preventDefault(); setDragHedefKod(kod); };
  const handleDrop = async (hedefKod: string, ustKod: string | null) => {
    if (!dragKod || dragKod === hedefKod) { setDragKod(null); setDragHedefKod(null); return; }
    const kardesler = getChildren(ustKod);
    const dragIdx = kardesler.findIndex(d => d.kod === dragKod);
    const hedefIdx = kardesler.findIndex(d => d.kod === hedefKod);
    if (dragIdx < 0 || hedefIdx < 0) { setDragKod(null); setDragHedefKod(null); return; }
    const yeniSira = [...kardesler];
    const [moved] = yeniSira.splice(dragIdx, 1);
    yeniSira.splice(hedefIdx, 0, moved);
    for (let i = 0; i < yeniSira.length; i++) {
      await fetch(`${API}/api/tanimlar2/kod/${encodeURIComponent(yeniSira[i].kod)}`, {
        method: 'PUT', headers: jsonHeaders(),
        body: JSON.stringify({ ad: yeniSira[i].ad, modul_baglantisi: yeniSira[i].modul || null, aciklama: yeniSira[i].aciklama || null, sira: i })
      });
    }
    setDragKod(null); setDragHedefKod(null);
    bildir('✅ Sıra güncellendi');
    yukle();
  };

  const PanelHeader = ({ baslik, seviyeAdi, ustKod, renk }: any) => (
    <div style={{ background: renk, color: 'white', padding: '8px 12px', fontSize: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
      <div style={{ overflow: 'hidden', flex: 1 }}>
        {seviyeAdi && (
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.65)', marginBottom: 2, fontWeight: 'normal', letterSpacing: '0.3px', textTransform: 'uppercase' }}>{seviyeAdi}</div>
        )}
        <div style={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{baslik}</div>
      </div>
      {isAdmin && (
        <button onClick={() => yeniAc(ustKod)}
          style={{ background: 'rgba(255,255,255,0.25)', border: 'none', color: 'white', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 16, flexShrink: 0, marginLeft: 6 }}>+</button>
      )}
    </div>
  );

  const PanelItem = ({ d, seviye, secili, ustKod, onClick }: any) => {
    const cocukSayisi = getChildren(d.kod).length;
    const isDragging = dragKod === d.kod;
    const isDragOver = dragHedefKod === d.kod && dragKod !== d.kod;
    const isPasif = d.aktif === 0 || d.aktif === false;
    return (
      <div draggable onDragStart={() => handleDragStart(d.kod)} onDragOver={e => handleDragOver(e, d.kod)}
        onDrop={() => handleDrop(d.kod, ustKod)} onDragEnd={() => { setDragKod(null); setDragHedefKod(null); }}
        onClick={onClick}
        style={{
          padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0',
          background: isPasif ? '#fff8f0' : isDragOver ? '#d4e6f1' : secili ? '#eaf4fb' : isDragging ? '#f0f0f0' : 'white',
          borderLeft: `3px solid ${isDragOver ? '#2471a3' : secili ? RENK[Math.min(seviye, 3)] : isPasif ? '#e67e22' : 'transparent'}`,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          opacity: isDragging ? 0.5 : isPasif ? 0.7 : 1,
        }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, flex: 1 }}>
          <span style={{ color: '#ccc', fontSize: 12, cursor: 'grab', flexShrink: 0 }}>⠿</span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: secili ? 'bold' : 'normal', color: isPasif ? '#e67e22' : secili ? RENK[Math.min(seviye, 3)] : '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {isPasif && '⚠ '}{d.ad}
            </div>
            <div style={{ fontSize: 10, color: '#aaa' }}>
              {d.kod}
              {d.modul && <span style={{ marginLeft: 4, background: '#eaf0fb', color: '#2471a3', padding: '0 4px', borderRadius: 3 }}>{d.modul}</span>}
              {isPasif && <span style={{ marginLeft: 4, background: '#fdebd0', color: '#e67e22', padding: '0 4px', borderRadius: 3 }}>pasif</span>}
              {cocukSayisi > 0 && <span style={{ marginLeft: 4, color: '#bbb' }}>{cocukSayisi} alt</span>}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 2, flexShrink: 0, marginLeft: 4 }} onClick={e => e.stopPropagation()}>
          {isAdmin && (
            isPasif ? (
              <button onClick={() => aktifEt(d.kod)} title="Aktif Et" style={{ background: '#27ae60', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>✓</button>
            ) : (
              <>
                <button onClick={() => tasiAc(d)} title="Taşı" style={{ background: '#2471a3', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>↕</button>
                <button onClick={() => duzenleAc(d)} title="Düzenle" style={{ background: '#e67e22', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>✏</button>
                <button onClick={() => sil(d.kod, d.ad)} title="Sil" style={{ background: '#e74c3c', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>Sil</button>
              </>
            )
          )}
          {cocukSayisi > 0 && <span style={{ color: '#ccc', fontSize: 11, alignSelf: 'center' }}>›</span>}
        </div>
      </div>
    );
  };

  const panel0 = getChildren(null);
  const panel1 = seciliPath[0] ? getChildren(seciliPath[0].kod) : [];
  const panel2 = seciliPath[1] ? getChildren(seciliPath[1].kod) : [];
  const panel3 = seciliPath[2] ? getChildren(seciliPath[2].kod) : [];
  const panel4 = seciliPath[3] ? getChildren(seciliPath[3].kod) : [];

  const panel5 = seciliPath[4] ? getChildren(seciliPath[4].kod) : [];

  const panels = [
    { key: 'p0', baslik: 'ANA MODÜLLER',    seviyeAdi: '',             ustKod: null,              items: panel0, seviye: 0 },
    ...(seciliPath[0] ? [{ key: 'p1', baslik: seciliPath[0].ad, seviyeAdi: 'Alt Modül',    ustKod: seciliPath[0].kod, items: panel1, seviye: 1 }] : []),
    ...(seciliPath[1] ? [{ key: 'p2', baslik: seciliPath[1].ad, seviyeAdi: 'Kategori',     ustKod: seciliPath[1].kod, items: panel2, seviye: 2 }] : []),
    ...(seciliPath[2] ? [{ key: 'p3', baslik: seciliPath[2].ad, seviyeAdi: 'Alt Kategori', ustKod: seciliPath[2].kod, items: panel3, seviye: 3 }] : []),
    ...(seciliPath[3] ? [{ key: 'p4', baslik: seciliPath[3].ad, seviyeAdi: 'Tanım',        ustKod: seciliPath[3].kod, items: panel4, seviye: 4 }] : []),
    ...(seciliPath[4] ? [{ key: 'p5', baslik: seciliPath[4].ad, seviyeAdi: 'Alt Tanım',    ustKod: seciliPath[4].kod, items: panel5, seviye: 5 }] : []),
  ];

  const ustSecenekler = duzListe.filter(d => tasiItem && d.kod !== tasiItem.kod && !d.kod.startsWith(tasiItem.kod + '.'));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 140px)' }}>
      <div style={{ paddingBottom: 12, flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 style={{ fontSize: 20, color: '#1a5276', margin: 0 }}>📚 Tanımlar</h1>
          <p style={{ color: '#666', fontSize: 12, margin: '4px 0 0' }}>
            ⠿ sürükleyerek sıralayın · ↕ ile taşıyın · ✏ ile düzenleyin · + ile yeni ekleyin · Sil ile kalıcı silin (alt kaydı olanlar silinemez)
          </p>
          {mesaj && <div style={{ background: '#d5f5e3', color: '#1e8449', padding: '8px 12px', borderRadius: 4, marginTop: 8, fontSize: 13 }}>{mesaj}</div>}
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, color: '#888', marginTop: 4, whiteSpace: 'nowrap' }}>
          <input type="checkbox" checked={pasifleriGoster} onChange={e => setPasifleriGoster(e.target.checked)} />
          Pasifleri göster
        </label>
      </div>

      {yukleniyor ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, color: '#999' }}>Yükleniyor...</div>
      ) : (
        <div style={{ display: 'flex', gap: 8, flex: 1, overflowX: 'auto', overflowY: 'hidden' }}>
          {panels.map((panel, idx) => (
            <div key={panel.key} style={{ width: idx === 0 ? 175 : 195, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 6, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden', flexShrink: 0 }}>
              <PanelHeader baslik={panel.baslik} seviyeAdi={panel.seviyeAdi} ustKod={panel.ustKod} renk={RENK[Math.min(panel.seviye, 3)]} />
              <div style={{ overflow: 'auto', flex: 1 }}>
                {panel.items.length === 0 ? (
                  <div style={{ padding: 14, color: '#999', fontSize: 12, textAlign: 'center' }}>
                    <div style={{ fontSize: 24 }}>📋</div>Öğe yok<br /><span style={{ fontSize: 11 }}>+ ile ekleyin</span>
                  </div>
                ) : panel.items.map(d => (
                  <PanelItem key={d.kod} d={d} seviye={panel.seviye} ustKod={panel.ustKod}
                    secili={seciliPath[panel.seviye]?.kod === d.kod}
                    onClick={() => secPanel(panel.seviye, d)}
                  />
                ))}
              </div>
            </div>
          ))}

          {!seciliPath[0] && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white', borderRadius: 6, color: '#999' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>📚</div>
                <div style={{ fontSize: 14 }}>Sol taraftan bir modül seçin</div>
                <div style={{ fontSize: 12, marginTop: 6, color: '#bbb' }}>H → Büyükbaş → Tür Tanımları → Sığır → Holstein...</div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 440 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modalMod === 'yeni' ? '+ Yeni Tanım' : modalMod === 'duzenle' ? '✏️ Düzenle' : '↕ Taşı'}</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              {modalMod === 'tasi' && tasiItem ? (
                <>
                  <div className="form-group">
                    <label>Taşınan</label>
                    <input className="form-control" value={`${tasiItem.ad} (${tasiItem.kod})`} disabled style={{ background: '#f5f5f5' }} />
                  </div>
                  <div className="form-group">
                    <label>Mevcut Üst</label>
                    <input className="form-control" value={tasiItem.ust_kod || 'Kök (Ana modül)'} disabled style={{ background: '#f5f5f5' }} />
                  </div>
                  <div className="form-group">
                    <label>Yeni Üst Modül *</label>
                    <select className="form-control" value={tasiHedef} onChange={e => setTasiHedef(e.target.value)}>
                      <option value="">Kök (Ana modül yap)</option>
                      {ustSecenekler.map(d => (
                        <option key={d.kod} value={d.kod}>{d.ad} ({d.kod})</option>
                      ))}
                    </select>
                  </div>
                </>
              ) : (
                <>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Kod * {modalMod === 'duzenle' && <small style={{ color: '#e67e22', fontWeight: 'normal' }}>değiştirilebilir</small>}</label>
                      <input className="form-control" value={form.kod}
                        onChange={e => setForm({ ...form, kod: e.target.value })} placeholder="H.1.1.1.1.5" />
                    </div>
                    <div className="form-group">
                      <label>Üst Kod</label>
                      <input className="form-control" value={form.ust_kod}
                        onChange={e => setForm({ ...form, ust_kod: e.target.value })} placeholder="H.1.1.1.1" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Ad *</label>
                    <input className="form-control" value={form.ad} autoFocus
                      onChange={e => setForm({ ...form, ad: e.target.value })} placeholder="Tanım adı" />
                  </div>
                  <div className="form-group">
                    <label>Modül Bağlantısı</label>
                    <input className="form-control" value={form.modul_baglantisi}
                      onChange={e => setForm({ ...form, modul_baglantisi: e.target.value })}
                      placeholder="örn: buyukbas_irk, tarla_ekim" />
                  </div>
                  <div className="form-group">
                    <label>Açıklama</label>
                    <textarea className="form-control" value={form.aciklama}
                      onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} />
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={modalMod === 'tasi' ? tasiKaydet : kaydet}>
                {modalMod === 'tasi' ? 'Taşı' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
